import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonImg, IonItem, IonLabel, IonList } from '@ionic/react';
import React from 'react';

import { css } from '@emotion/react';
import type { NetworkSummaryDto } from '../../types';
import { SkeletonText } from '../SkeletonText';
import { Title } from '../Title';

interface NetworkNotFoundProps {
  networks?: NetworkSummaryDto[];
}

export const NetworkSelector: React.FC<NetworkNotFoundProps> = ({ networks }) => {
  const networkSelectorCss = {
    logo: [
      css({
        height: '1rem',
        marginRight: '.5rem',
        width: '4rem',
      }),
    ],
  };
  return (
    <IonCard>
      <IonCardHeader>
        <IonCardTitle>
          <Title level={2}>Available Networks</Title>
        </IonCardTitle>
      </IonCardHeader>
      <IonCardContent>
        <IonList>
          {networks
            ? networks
                .filter((n) => n.visible ?? true)
                .map(({ networkId, name, logoUrl }) => (
                  <IonItem key={networkId} routerLink={`/${networkId}`} detail>
                    <IonImg css={networkSelectorCss.logo} src={logoUrl} />
                    <IonLabel>{name}</IonLabel>
                  </IonItem>
                ))
            : [...Array(3)].map((_, idx) => (
                <IonItem key={idx}>
                  <IonLabel>
                    <SkeletonText />
                  </IonLabel>
                </IonItem>
              ))}
        </IonList>
      </IonCardContent>
    </IonCard>
  );
};
